import { useQuery } from "react-query";
import { getSafeTypeList } from "../../../../../actions/Utilities/SafeType";

export default function useGetSafeTypeList() {
  return useQuery("GetSafeType", getSafeTypeList, {
    refetchOnWindowFocus: false,
  });
}
